'use client'

import { forwardRef, useImperativeHandle, useEffect, useRef, useState } from "react"
import Modal from "@/components/modal/Modal";
import styles from "./ua.module.scss";
import {APIProvider, AdvancedMarker, Map, Marker} from '@vis.gl/react-google-maps';
import axios from "axios";
import { OEM_META } from "@/components/OEM";
import { normalizedImageUrl } from "@/utils/ImageUtils";
import StackedPanel from "@/components/panel/StackedPanel";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelTitle from "@/components/panel/PanelTitle";
import Button from "@/components/button/Button";
import PanelBody from "@/components/panel/PanelBody";
import Icon from "@/components/icon/Icon";

const DealerSelectorPopup = forwardRef((props, ref) => {
  
  const modal = useRef()
  const map = useRef()

  const myPosition = { lat: parseFloat(props.site?.session?.vehicles?.location.lat), lng: parseFloat(props.site?.session?.vehicles?.location.lon) }
  const [position,setPosition] = useState(myPosition)
  const [dealers,setDealers] = useState([])
  const [zoom,setZoom] = useState(10)
  const [visible,setVisible] = useState(false)

  useEffect(() => {
  }, [])

  const load = async () => {
    const resp = await axios.get("/api/dealer/search?lat=" + position.lat + "&lon=" + position.lng, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    })
    if (resp.status == 200) {
      const data = resp.data
      setDealers(data)
    }  
  }
  
  const show = () => {
    load()
    setVisible(true)
    modal.current.show()
  }
  
  const hide = (e) => {
    setTimeout(() => {
      setVisible(false)
    }, 1000)
    setVisible(true)
    modal.current.hide()
  }

  const onMapChange = (info) => {
    setZoom(info?.detail?.zoom)
    setPosition(info?.detail?.center)
  }
  
  useImperativeHandle(ref, () => ({
    show, hide
  }))

  const icon = normalizedImageUrl(props.site.siteSettings.favicon)
  
  return <Modal ref={modal}>
    <div className={styles.selector}>
      <StackedPanel className={styles.panel}>
        <PanelHeader>
          <PanelTitle leftPad={true} centered={true}>
            <h2>{ 'Select a Dealer' }</h2>
          </PanelTitle>
          <div>
            <Button theme={'icon'} onClick={e => hide(e)} label={ 'Close' }>
              <span className="ico-smaller"><Icon {...props} name="x"></Icon></span>
            </Button>
          </div>
        </PanelHeader>
        <PanelBody>
          <div className={styles['selector-list']}>
            { dealers.map((item,index) => (
              <a key={index} className={styles['selector-item']} target="_blank" href={item.service_url}>
                <div className={styles['selector-item-info']}>
                  <div className={styles['selector-item-dealer']}>
                    <div className={styles['selector-item-name']}>{ item.name }</div>
                    <div className={[]}>{ item.distance } miles</div>
                  </div>
                  <div className={styles['selector-item-line']}>{ item.address.street_address.trim() }, { item.address.city.trim() }, { item.address.state.trim() }</div>
                </div>
              </a>
            ))}
          </div>
        </PanelBody>
      </StackedPanel>
      <div className={styles['selector-map']}>
        { visible &&
        <APIProvider apiKey={'AIzaSyBTRlRGNulPsfFTk_JLlrHJ6QCpkLfTqbc'}>
          <Map mapId="dealers_map" center={position} zoom={zoom} onZoomChanged={e => onMapChange(e)} onCenterChanged={e => onMapChange(e)}>
            <AdvancedMarker position={myPosition} />
            { dealers.map((d,index) => (
              // <Marker key={index} position={{ lat: d.lat, lng: d.lon }} />
              <AdvancedMarker key={index} position={{ lat: d.lat, lng: d.lon }}>
                <div className={styles['selector-marker']}>
                  <img src={ normalizedImageUrl(props.site.siteSettings.favicon) } alt={ d.name } width={'18px'} height={'18px'}></img>
                </div>
              </AdvancedMarker>
            ))}
          </Map>
        </APIProvider>
        }
      </div>
    </div>
  </Modal>
  
})

DealerSelectorPopup.displayName = "DealerSelectorPopup";
export default DealerSelectorPopup;